// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type ProductSummary = {
  label: string,
  config_name: string,
  prices: Array<{
    currency: string,
    min_duration: number,
    price_after_taxes: number,
    price_before_taxes: number,
  }>,
  taxes: Array<{
    rate: number,
  }>,
};

export type State = {
  list: ListState<ProductSummary>,
};

export type ProductsResourceType = SequoiaResourceType<{
  fetchResource: ProductSummary,
}>;

export type ProductsResource = SequoiaResource<ProductsResourceType>;

export const productsResource: ProductsResource = createSequoiaResource(
  'mailbox-standalone',
  'products',
  {
    fetchPath: 'mailboxsa-anonymous/products',
    getResourceId(resource) {
      return resource.config_name;
    },
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...productsResource.listReducer,
});
